/** localStorage key used to persist the user's selected code text size. */
export const FONT_SIZE_STORAGE_KEY = "techdocs.addons.settings.code-text-size";

/** Custom event name dispatched when the active code text size changes. */
export const FONT_SIZE_CHANGE_EVENT = "code-text-size-change";

/** Discrete step values (as percentage integers) available in the size slider. */
export const FONT_SIZE_MARKS = [
    { value: 90 },
    { value: 100 },
    { value: 115 },
    { value: 130 },
    { value: 150 },
];

/** Array of valid size percentage values derived from {@link FONT_SIZE_MARKS}. */
export const FONT_SIZE_VALUES = FONT_SIZE_MARKS.map(m => m.value);

/** Minimum allowed code text size percentage. */
export const FONT_SIZE_MIN = FONT_SIZE_VALUES[0];

/** Maximum allowed code text size percentage. */
export const FONT_SIZE_MAX = FONT_SIZE_VALUES[FONT_SIZE_VALUES.length - 1];

/** Default code text size percentage applied when no stored value exists. */
export const FONT_SIZE_DEFAULT = 100;

/**
 * Formats a numeric size value as a CSS percentage string.
 *
 * @param v - Size value as an integer percentage (e.g. `100`).
 * @returns Formatted string (e.g. `"100%"`).
 */
export const formatSizeText = (v: number) => `${v}%`;

/**
 * Parses a raw string into a valid size percentage integer.
 *
 * @param raw - Raw string read from localStorage or a URL param.
 * @returns The parsed value if it is in {@link FONT_SIZE_VALUES}, otherwise {@link FONT_SIZE_DEFAULT}.
 */
export function parseSize(raw: string): number {
    const parsed = parseInt(raw, 10);
    return FONT_SIZE_VALUES.includes(parsed) ? parsed : FONT_SIZE_DEFAULT;
}
